module.exports = __webpack_public_path__ + "static/work-3-2774fe846df7091e8849e5d71e9cc601.png";